export const exportToExcelInvestigationRoadAccidentService =
  (fetch) => async (filters) => {
    try {
      const searchParams = new URLSearchParams(filters).toString();
      const response = await fetch({
        url: `/api/v1/siniestros-viales/investigaciones/export?${searchParams}`,
        responseType: "blob",
      });

      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      return blob;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
